import { Button } from '@auviknetworks/iceberg-ui';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

/**
 * A React component that renders a button as a link or an external link based on the row data.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.row - The row data object containing the cell value and other properties.
 * @param {Object} props.cell - The cell data object containing the cell value.
 * @returns {JSX.Element} The rendered component.
 */
export const LinkCell = ({ row, cell }) => {
    const { t } = useTranslation();
    // If the row data indicates an external link
    if (row.original.external) {
        // Render an anchor tag with the cell value as the href
        return (
            <a
                target="_blank"
                href={cell.getValue()}
                rel="noopener noreferrer nofollow"
                data-trackid="linkCell_routeTo"
            >
                <Button data-trackid="linkCell" variant="primary">
                    {t(row.original.action)}
                </Button>
            </a>
        );
    }
    // Render a React Router Link component with the row data's page property as the path
    return (
        <Link to={cell.getValue()} data-trackid="linkCell_routeTo">
            <Button data-trackid="linkCell" variant="primary">
                {t(row.original.action)}
            </Button>
        </Link>
    );
};
